import { useState, useEffect, useRef } from 'react'
import { colors } from '@/constant/colors'
import DragAndDropQuestion from './drag-and-drop-question'

interface PracticeGrammarDragAndDropProps {
  question: any;
  handleAnswer: (option: string, isCorrect: boolean, autoSubmit?: boolean) => void;
  currentAnswer: any;
  disabled: boolean;
  isReview?: boolean;
  onInputChange?: (value: string) => void;
  triggerCheck?: boolean;
}

const PracticeGrammarDragAndDrop = ({
  question,
  handleAnswer,
  currentAnswer,
  disabled,
  isReview = false,
  onInputChange,
  triggerCheck
}: PracticeGrammarDragAndDropProps) => {
  const [submitted, setSubmitted] = useState(false)

  const isSubmitDisabled = disabled || submitted;

  useEffect(() => {
    if (isReview) {
      setSubmitted(true)
    }
  }, [isReview])

  useEffect(() => {
    if (currentAnswer.selectedOption === null) {
      setSubmitted(false)
    }
  }, [currentAnswer])

  // 响应外部的Check触发
  useEffect(() => {
    if (triggerCheck && !submitted) {
      setSubmitted(true)
    }
  }, [triggerCheck])

  return (
    <div>
      <DragAndDropQuestion
        question={question}
        handleAnswer={handleAnswer}
        currentAnswer={currentAnswer}
        disabled={disabled}
        isReview={isReview}
        bgColor={colors.mainBgColor}
        submitted={submitted}
        onInputChange={onInputChange}
      />
    </div>
  )
}

export default PracticeGrammarDragAndDrop